import React from "react";
import { ExpandedDescriptionSpecificationTable } from "~/ProductDetails/ProductDetailPageResult";
interface Props {
  specificationSummary: ExpandedDescriptionSpecificationTable[];
}
const SpecificationSummary = ({
  specificationSummary
}: Props) => {
  return <div className="detail-section py-7 px-5 text-center" data-testid="spec-summary" data-sentry-component="SpecificationSummary" data-sentry-source-file="SpecificationSummary.tsx">
      {specificationSummary.map(x => <div className="inline-block m-auto m-0 px-3 pb-4 text-center align-top" key={x.name}>
          <b>{`${x.name}:`}</b>
          <dl className="list-none mt-1 p-0 block overflow-hidden shadow border border-solid rounded-sm border-zinc-300" key={x.name}>
            {x.specifications.map((y, i) => <span className={`table w-full box-border m-0 px-4 py-2 ${i % 2 ? "bg-neutral-100" : ""}`} key={y.name + y.value}>
                <dt className="font-semibold pr-5 table-cell text-left text-sm">{`${y.name}:`}</dt>
                <dd className="table-cell text-right text-sm">{y.value}</dd>
              </span>)}
          </dl>
        </div>)}
    </div>;
};
export default SpecificationSummary;